

























































































import { EventBus } from '@/event-bus.js';

import {

  genPostReq
} from "@/services/checklist.service";



export default {
  watch: {
    '$route' (to, from) {
      //console.log("route change", to, from)
    }
  },  
  data() {
    return {
      treeData: [], 
      activeTreeRow: {},
      initLoaded: false, 
      bc: null, 
      currentSelectedItem: null, 
      pasteItem: {},
      pasteActionType: null,
      insert_dialog: false, 
      targetItem: {}, 
      loadingProcessing: false, 
    };
  },
  components: {
  },
  methods: {
    pasteAction() {
        let pasteItemPath = this.genCompTree(this.pasteItem).reverse()
        let itemPath = this.genCompTree(this.targetItem).reverse()
        //console.log("--- ", this.pasteItem.id.split("_")[1], "____", pasteItemPath, itemPath)

        if (this.pasteActionType == "copy") {
            this.duplicateTree(itemPath)
        }
        else {
            this.moveTree(itemPath)
        }

    },
    copyRow(item) {
        this.pasteItem = item
        this.pasteItem.cl_uid = this.$store.state.cl_uid

        this.pasteActionType = "copy" 

        console.log( 'copyRow', this.pasteItem, this.pasteActionType )

        this.bc.postMessage({type: 'COPY_COMP',  cl_uid: this.$store.state.cl_uid, pasteItem: this.pasteItem });
    },
    cutRow(item) {
        this.pasteItem = item
        this.pasteItem.cl_uid = this.$store.state.cl_uid

        this.pasteActionType = "cut"
    },
    insertRow(item) {

        this.targetItem = item
       
        let pasteItemPath = this.genCompTree(this.pasteItem).reverse()

        if (this.pasteActionType == 'cut') {
            for (let k=0 ; k<pasteItemPath.length ; k++) {
                if(pasteItemPath[k].id == item.id.split("_")[1]) {
                    alert(this.$t('LABEL129'))
                    return 
                }
            }
        }
     
       this.insert_dialog  = true
    },
    inspectionToTree(tree_item, inspection, k) {    
      if (inspection.components && inspection.components.length > 0) {
      
        for (var i=0 ; i<inspection.components.length ; i++) {
          k++
          //console.log("inspection.components[i]", inspection.components[i])
          let item = { name: inspection.components[i].name.de, 
                       parent_id: inspection.components[i].parent_id,
                       id: k+"_"+inspection.components[i]._id, 
                       children: [] }
          this.inspectionToTree(item.children, inspection.components[i], k)
          tree_item.push(item)
        }
      }

      this.activeTreeRow = []
    },
    findInTree(list, id) {
        for (let k of list) {
            if (k.id.split("_")[1] == id) {
                return k
            }
            if (k.children.length > 0) {
                let v =  this.findInTree(k.children, id)
                if (v) {
                    return v
                }
            }
        }
    },
    genCompTree(item) {
        let comp_path = [{ id: item.id.split("_")[1], name: item.name }]

        if (item.parent_id) {
            let b = this.findInTree(this.treeData, item.parent_id)

        
            if (b) {
                comp_path.push({ id: b.id.split("_")[1], name: b.name })
                while ( b.parent_id) {
                    b = this.findInTree(this.treeData, b.parent_id)
                    comp_path.push({ id: b.id.split("_")[1], name: b.name })
                }
            }
        }
        return comp_path
    },
    openTreeItem(item) {
      this.tasks = []
      var ref = this
     
        if (item && item[0]) {
             // Pfad suchen
             //console.log(this.treeData)

             if (this.currentSelectedItem == item[0].id) {
                 return 
             }

             this.currentSelectedItem = item[0].id
             let comp_path = this.genCompTree(item[0])

             //console.log("comp_path", comp_path.reverse())
             if (comp_path.length > 0) {
                this.bc.postMessage({type: 'SELECT_COMP', cl_uid: this.$store.state.cl_uid, comp_path: comp_path.reverse() });
             }
        }
    },

    loadTree() {
      this.loadingProcessing = true
      genPostReq('checklist', 'component-tree', { cl_uid: this.$store.state.cl_uid })
      .then(resp => {
          console.log(resp)
        this.$store.state.headerTitle = resp.data.cl_name
        this.treeData = []
        this.pasteItem = {}
        this.initLoaded = true
        this.inspectionToTree(this.treeData, resp.data.components, 0)
        
        this.loadingProcessing = false
      })
    },
    moveTree(itemPath) {
        this.insert_dialog = false
        this.loadingProcessing = true

      genPostReq('checklist', 'move-comp', { cl_uid: this.pasteItem.cl_uid, 
                                            entry_uid: this.pasteItem.id.split("_")[1],
                                            target_cl_uid: this.$store.state.cl_uid,
                                            target_entry_uid: this.targetItem.id.split("_")[1]  })
      .then(resp => {
          console.log("moveTree", resp)
          this.loadingProcessing = false
          this.loadTree()
      })
    },
    duplicateTree(itemPath) {
      this.insert_dialog = false
      this.loadingProcessing = true

      //console.log(this.$store.state.cl_uid, this.pasteItem.id.split("_")[1], this.$store.state.cl_uid, this.targetItem.id.split("_")[1])

      genPostReq('checklist', 'duplicate-comp', { cl_uid: this.pasteItem.cl_uid, 
                                                  entry_uid: this.pasteItem.id.split("_")[1],
                                                  target_cl_uid: this.$store.state.cl_uid,
                                                  target_entry_uid: this.targetItem.id.split("_")[1]  })
      .then(resp => {
          console.log("duplicateTree", resp)
          this.loadingProcessing = false
          this.loadTree()
      })
    }
   
  },
  destroyed() {
   
  },
  mounted() {
    this.$store.state.cl_uid = this.$route.params.uid;

    if (!this.bc) {
        this.bc = new BroadcastChannel('checklist');
        this.bc.onmessage = (eventMessage) => {

            if (eventMessage.data && 
                eventMessage.data.type == "RELOAD_TREE" && 
                eventMessage.data.cl_uid == this.$store.state.cl_uid) {
                console.log("RELOAD _ TREE")
                this.loadTree()
            }

            if (eventMessage.data && 
                eventMessage.data.type == "COPY_COMP" && 
                eventMessage.data.cl_uid != this.$store.state.cl_uid) {
                this.pasteActionType = "copy"
                this.pasteItem = eventMessage.data.pasteItem
            }
        } 
    }
  
    this.loadTree()

  

  

  },
  computed: {

   
  }
};
